// @flow
export { default } from './WriteMobileTitle';



// WEBPACK FOOTER //
// ./src/components/write/WriteMobileTitle/index.js